<div class="Forbidden" [style.background-image]="'url(assets/imgs/bhavani_mushroom.jpg)'">
  <div class="Forbidden__Img">
    <img class="img-responsive" alt="Imagen 404" i18n-alt width="250" src="assets/imgs/Bhavani_blanco.png" alt="">
  </div>
</div>